import { useContext } from 'react'
import { StoreContext } from './storeProvider'

export const useStore = (context = StoreContext) => {
  const store = useContext(context)
  if (!store) {
    throw new Error()
  }
  return store
}
